<template>
  <div class="overview-column tariff-column">
    <div class="content-box">
      <TariffOptionsIcon :value="value" />
      <div class="tariff-option-name text-2xl-semibold no-wrap-ellipsis">
        {{ option.name }}
      </div>
      <img class="tariff-option-select-icon" src="/files/lidl/images/new-icons/svg/angle-right.svg" alt="" />
    </div>
  </div>
</template>
<script>
import TariffOptionsIcon from './TariffOptionsIcon.vue'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'TariffOptionsList',
  components: {
    TariffOptionsIcon
  },
  methods: {
    detailsAction(option) {
      this.$emit('details', option)
    }
  },
  computed: {
    value() {
      return `${!this.option.flat ? this.option.extraDataVolumes[0].primary : 'Flat'}`
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    currentTariffId: {
      type: String,
      default: '82'
    },
    clicked: {
      type: Array,
      default: () => []
    }
  },
  mixins: [slotProxy()]
}
</script>

<style lang="scss" scoped>
.tariff-option-name {
  color: var(--gray-900, var(--gray-900, #111928));
}
</style>
